import API_CONFIG from '@/config/api.config';

export interface PlatformStatus {
  maintenance_mode: boolean;
  maintenance_message: string;
  vacancies_globally_paused: boolean;
  vacancies_pause_message: string;
}

export async function fetchPlatformStatus(): Promise<PlatformStatus | null> {
  try {
    const res = await fetch(`${API_CONFIG.BASE_URL}/api/public/platform-status`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return null;
    return (await res.json()) as PlatformStatus;
  } catch {
    return null;
  }
}
